// PaymentService.tsx
import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, DeleteData, PaginationParams, Wrapper } from '../../type';
import {
  DeletePaymentResponse,
  GetAdjustedInvoicesPaymentResponse,
  GetPaymentByIdResponse,
  GetPaymentInvoiceResponse,
  GetPaymentModeByIdResponse,
  GetPaymentModeDropdownResponse,
  GetPaymentModeResponse,
  GetPaymentResponse,
  GetPaymentsCreditRequest,
  GetPaymentsCreditResponse,
  PaymentMode,
  PaymentsRequest,
  PaymentsResponse,
} from './interface';

export class PaymentProfile extends BaseService {
  async createPayment(req: PaymentsRequest) {
    return this.post<PaymentsResponse, PaymentsRequest>(`${this.apiUrl}/api/payments`, req);
  }

  async getPayment(params: PaginationParams) {
    return this.get<GetPaymentResponse>(`${this.apiUrl}/api/${params.typeName}`, params);
  }

  async updatePayment(id: number, req: PaymentsRequest) {
    return this.put<PaymentsResponse, PaymentsRequest>(`${this.apiUrl}/api/payments/${id}`, req);
  }

  async deletePayment(id: number) {
    return this.delete<DeletePaymentResponse>(`${this.apiUrl}/api/payments/${id}`);
  }

  async getPaymentsCreditSales(params: GetPaymentsCreditRequest) {
    return this.get<GetPaymentsCreditResponse>(`${this.apiUrl}/api/payments/credit`, params);
  }

  async getPaymentsCredit(id: number, typeName: string) {
    return this.get<GetPaymentsCreditResponse>(`${this.apiUrl}/api/${typeName}/${id}`);
  }

  async getPaymentsInvoice(params: PaginationParams & { clientId: number }) {
    return this.get<GetPaymentInvoiceResponse>(`${this.apiUrl}/api/invoices/unpaid/paged`, params);
  }

  async getPaymentByID(id: number) {
    return this.get<GetPaymentByIdResponse>(`${this.apiUrl}/api/payments/${id}`);
  }

  async createPaymentMode(req: PaymentMode) {
    return this.post<GetPaymentModeByIdResponse, PaymentMode>(`${this.apiUrl}/api/paymentmode`, req);
  }

  async getPaymentMode(params: PaginationParams) {
    return this.get<GetPaymentModeResponse>(`${this.apiUrl}/api/paymentmode/paged`, params);
  }

  async getPaymentModeDropdown(params: PaginationParams) {
    return this.get<GetPaymentModeDropdownResponse>(`${this.apiUrl}/api/paymentmode/get`, params);
  }

  async updatePaymentMode(id: number, req: PaymentMode) {
    return this.put<GetPaymentModeByIdResponse, PaymentMode>(`${this.apiUrl}/api/paymentmode/${id}`, req);
  }

  async deletePaymentMode(id: number) {
    return this.delete<DeleteData>(`${this.apiUrl}/api/paymentmode/${id}`);
  }

  async getPaymentModeByID(id: number) {
    return this.get<GetPaymentByIdResponse>(`${this.apiUrl}/api/paymentmode/${id}`);
  }

  async getAdjustedInvoicesPayment(id: number) {
    return this.get<GetAdjustedInvoicesPaymentResponse>(`${this.apiUrl}/api/payments/getinvoices/bypaymentid/${id}`);
  }

  async changeStatusPaymentMode(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<Wrapper, ChangeStatusRequest>(`${this.apiUrl}/api/paymentmode/${active}/${id}`, req);
  }
}
